import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import BloodMain from './BloodMain';

const BloodDonation = () => {
  return (
    <>
      <HeaderSeven />
      <BloodMain />
      <Footer />
    </>
  );
};

export default BloodDonation;
